import React from 'react'
import Shell from './landingPages/pages/Shell'
import LandingPage from './landingPages/pages/LandingPage'
import JobPosting from './landingPages/pages/JobPosting'
import JobsShell from './jobBoard/pages/JobsShell'
import JobsHome from './jobBoard/pages/JobsHome'
import JobsJobPosting from './jobBoard/pages/JobsJobPosting'

const routes = [
  {
    path: '/jobs',
    element: <JobsShell />,
    children: [
      {
        index: true,
        element: <JobsHome />
      },
      {
        path: ':identifier',
        element: <JobsJobPosting />
      }
    ]
  },
  {
    path: '/landing/:landing_page_identifier',
    element: <Shell />,
    children: [
      {
        index: true,
        element: <LandingPage />
      },
      {
        path: ':job_posting_identifier',
        element: <JobPosting visibility='public' />
      },
      {
        path: 'private/:job_posting_identifier',
        element: <JobPosting visibility='private' />
      }
    ]
  },
  {
    path: '/landing/embeddable/:landing_page_identifier',
    children: [
      {
        index: true,
        element: <LandingPage embedded />
      },
      {
        path: ':job_posting_identifier',
        element: <JobPosting visibility='public'/>
      }
      // Private job postings are not available through the embeddable routes
    ]
  }
]

export default routes
